import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ReportHeading from "../../Components/ReportHeadings/ReportHeadings";
import DivTag from "../../Components/DivComponent/DivTag";
import Popup from "../../Components/Popup/Popup";
import FormValidation from "../../Components/FormValidation/FormValidation";
import InputWithLabel from "../../Components/InputComponent/InputWithLabel";
import Button from "../../Components/ButtonComponent/Button";
import {
  AddPackageService,
  fetchOperatorService,
  retriveServiceCharge,
  updatePackageService,
  retrivePackageServiceByTotal,
  fetchAllPackagesCharges,
} from "../../../services/PackageList/PackageService";
import { FaInbox } from "react-icons/fa";
import Seo from "../../../components/SeoComponent/Seo";
import { RetriveServiceReportService3 } from "../../../services/apiaddservice";
import { linkServicePackage } from "../../../services/apiService";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import { ToastContainer } from "react-toastify";
import { ChevronUpCircleIcon, ChevronUpIcon, XCircle } from "lucide-react";

const CommissionMaster = () => {
  const initialState = {
    service: "",
    status: "",
  };
  const [packageName, setPackageName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [packageID, setPackageID] = useState("");
  const [editingPackageId, setEditingPackageId] = useState(null);
  const [newName, setNewName] = useState("");
  const [serviceData, setServiceData] = useState([]);
  const [selectedService, setSelectedService] = useState();
  const [selectedPackageId, setSelectedPackageId] = useState("");
  const [commissionSlab, setCommisssionSlab] = useState([]);
  const [paymentMode, setPaymentMode] = useState("");
  const [charges, setCharges] = useState("");
  const [chargeType, setChargeType] = useState("");
  const [editIndex, setEditIndex] = useState(null);
  const [deletIndex, setDeletIndex] = useState(null);
  const [openServiceDropDown, setOpenServiceDropDown] = useState(false);
  const [serviceLabel, setServiceLabel] = useState("");
  const [filteredServices, setFilteredServices] = useState(serviceData);
  const [showAllPackageCharges, setShowAllPackageCharges] = useState([]);
  const [operators, setOperators] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [operatorID, setSelectedOperatorID] = useState("");
  const [debitType, setDebitType] = useState("");
  const [statusRes, setStatusRes] = useState("");

  useEffect(() => {
    const loadOperators = async () => {
      try {
        const response = await fetchOperatorService({ category: "Prepaid" });
        // Adjust according to API response shape
        if (response.status === "success" || response.status?.code === 200) {
          setOperators(response.data || response.operators || []);
          setSelectedOperatorID(response.data.operator_id || "");
        }
      } catch (error) {
        console.error("Failed to fetch operators:", error);
      }
    };

    loadOperators();
  }, []);

  useEffect(() => {
    console.log("service data");

    console.log(serviceData);
  }, [serviceData]);

  const handleChange = (e) => {
    setSelectedOperator(e.target.value);
    setSelectedOperatorID(e.target.value);
  };

  // Filter services based on what the user types
  useEffect(() => {
    if (serviceLabel.trim() === "") {
      setFilteredServices(serviceData); // show all when input empty
    } else {
      const searchText = serviceLabel.toLowerCase();

      setFilteredServices(
        serviceData.filter(
          (item) => item.service_name.toLowerCase().includes(searchText), // simple match anywhere
        ),
      );
    }
  }, [serviceLabel, serviceData]);

  // ENd

  const validate = (values) => {
    let errors = {};
    if (!values.SelectService || values.SelectService === "") {
      errors.SelectService = "Service is required";
    }
    if (!values.SelectStatus || values.SelectStatus === "") {
      errors.SelectStatus = "Status is required";
    }
    return errors;
  };

  const [to_amt_val, setto_amt_val] = useState("");
  const handleToAmt = (event) => {
    setto_amt_val(event.target.value);
  };

  const [isOpen, setIsOpen] = useState(false);
  const openPopup = () => {
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
  };

  const [from_amt_val, setfrom_amt_val] = useState("");
  const handleFromAmt = (event) => {
    setfrom_amt_val(event.target.value);
  };

  const { errors, handleBlur } = FormValidation(initialState, validate);

  //AddBank Data Function
  async function AddPackageData() {
    try {
      setIsLoading(true);
      const response = await AddPackageService({
        name: packageName,
      });
      if (response.status === 422) {
        showErrorToast("Package Already exists");
        return;
      }
      if (response.status.code === 200) {
        showSuccessToast(response.status.message);
        await RetrivePackageData();
        return;
      }
      setPackageName("");
      setIsLoading(false);
      return;
    } catch (error) {
      console.log(error);
    }
  }
  // End

  // Retrive Bank Data Function
  async function RetrivePackageData() {
    try {
      const response = await retrivePackageServiceByTotal({
        total: 100,
      });
      setPackageData(response.data);
    } catch (error) {
      return error;
    }
  }

  async function retriveSrviceReport() {
    if (isLoading) return;

    try {
      setIsLoading(true);

      let allData = [];
      let page = 1;
      let hasNext = true;

      while (hasNext) {
        const response = await RetriveServiceReportService3({
          page,
          per_page: 300,
        });

        if (response?.status?.code !== 200) break;

        allData = [...allData, ...(response?.data?.services?.data || [])];

        if (!response?.services?.next_page_url) {
          hasNext = false;
        } else {
          page++;
        }
      }

      setServiceData(allData);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    RetrivePackageData();
    retriveSrviceReport();
  }, []);
  // ENd

  // Handle Edit button click
  const handleEdit = (package_id, name) => {
    setPackageID(package_id);
    setEditingPackageId(package_id); // Set the package ID to the one being edited
    setNewName(name); // Set the current name to the new name
  };

  // Handle Update button click
  const handleUpdate = async (id) => {
    try {
      const response = await updatePackageService({
        name: newName,
        package_id: id,
      });
      if (response.status.code === 200) {
        await RetrivePackageData();
        showSuccessToast(response.status.message);
        setEditingPackageId(null);
      } else {
        showErrorToast(response.data.message);
        setEditingPackageId("");
        return;
      }
    } catch (error) {
      console.error("Error during update:", error);
    }
  };

  function addCommissionSlab() {
    const addedItem = {
      amount: parseFloat(charges),
      start_amount: parseFloat(from_amt_val),
      end_amount: parseFloat(to_amt_val),
      commission_type: chargeType,
      mode: paymentMode,
      operator_id:
        selectedService &&
        serviceData.find((s) => s.id === Number(selectedService))?.end_point ===
          "/bills-api/recharge"
          ? selectedOperator // <-- use selectedOperator here
          : null, // or skip if not Recharge
    };

    if (
      (isNaN(addedItem.start_amount) || isNaN(addedItem.end_amount)) &&
      debitType === "Transaction"
    ) {
      showErrorToast("Please enter valid slab amounts");
      return false;
    }

    if (addedItem.start_amount >= addedItem.end_amount) {
      showErrorToast("Start amount must be less than end amount");
      return false;
    }
    setCommisssionSlab((prev) => [...prev, addedItem]);
    return true;
  }

  useEffect(() => {
    const fetchCharge = async () => {
      if (selectedPackageId && selectedService) {
        try {
          const response = await retriveServiceCharge({
            serviceId: selectedService,
            packageId: selectedPackageId,
          });

          setStatusRes(
            response?.data?.packaged_service?.service?.status_id || "",
          );

          const fetchedSlabs =
            response?.data?.packaged_service?.commission_slabs || [];

          // Mark them as coming from DB
          const dbSlabs = fetchedSlabs.map((slab) => ({
            ...slab,
            isDb: true,
          }));

          setCommisssionSlab(dbSlabs);

          const isRecharge =
            selectedService &&
            serviceData.find((s) => s.id === Number(selectedService))
              ?.end_point === "/bills-api/recharge";

          // set charge & type conditionally
          if (isRecharge) {
            setCharges("");
            setChargeType("");
          } else {
            const amount =
              response?.data?.packaged_service?.service_charge?.amount;
            const chargeType =
              response?.data?.packaged_service?.service_charge?.charge_type;
            setCharges(amount || "");
            setChargeType(chargeType || "");
          }
        } catch (error) {
          console.error("Failed to fetch slab:", error);
          setCommisssionSlab([]);
        }
      }
    };

    fetchCharge();
  }, [selectedPackageId, selectedService]);

  function filterSelctedItem() {
    if (!selectedService) return [];
    return serviceData.filter(
      (curr) => String(curr.id) === String(selectedService),
    );
  }
  //  console.log("charge type",filterSelctedItem()[0]?.adjustment_type)

  async function handleSubmitPackageLinking() {
    try {
      const selectedItem = filterSelctedItem()[0];

      if (!selectedItem) {
        return showErrorToast("Please select a valid service");
      }

      const isChargeType =
        selectedItem.adjustment_type === "charge" &&
        selectedService &&
        serviceData.find((s) => s.id === Number(selectedService))?.end_point !==
          "/idfc/fund-transfer";

      const payload = {
        service_id: selectedService,
        package_id: selectedPackageId,
        amount: charges,
        debit_type: debitType,
        mode: paymentMode,
        charge_type: chargeType,
        ...(isChargeType ? {} : { commission_slabs: commissionSlab }),
      };

      if (
        !isChargeType &&
        commissionSlab.length <= 0 &&
        debitType === "Transaction"
      ) {
        return showErrorToast("Add at least 1 slab");
      }

      function hasOverlappingSlabs(slabs) {
        const sorted = [...slabs].sort((a, b) => a.from_amount - b.from_amount);
        for (let i = 1; i < sorted.length; i++) {
          const prev = sorted[i - 1];
          const curr = sorted[i];
          if (curr.from_amount <= prev.to_amount) {
            return true; // Overlapping or nested
          }
        }
        return false;
      }

      if (!isChargeType && hasOverlappingSlabs(commissionSlab)) {
        return showErrorToast(
          "Commission slabs cannot have overlapping or nested ranges.",
        );
      }

      const response = await linkServicePackage(payload);

      if (response.status.code === 422) {
        const errorMessage =
          response.message ||
          (response.errors && response.errors[0]) ||
          "Overlapping or nested commission slabs detected.";
        showErrorToast(errorMessage);
        return;
      }
      if (
        response.status.code === 201 ||
        response.status.code === 200 ||
        response.status === 201 ||
        response.status === 200
      ) {
        // Clear form fields
        setChargeType("");
        setCharges(0);

        if (!isChargeType) {
          setCommisssionSlab([]);
          addCommissionSlab();
          setfrom_amt_val("");
          setto_amt_val("");
          setSelectedOperatorID("");
          setChargeType("");
        }

        showSuccessToast(response.status.message || response.message);
      } else {
        showErrorToast(
          response?.status?.message ||
            response?.message ||
            "Overlapping or nested commission slabs detected.",
        );
      }
    } catch (error) {
      // Catch and display error from server or JS error
      if (error?.response?.data?.status?.message) {
        showErrorToast(error.response.data.status.message);
      } else if (error?.message) {
        showErrorToast(error.message);
      } else {
        showErrorToast("Server error. Please try again later.");
      }
    }
  }

  // Slab Start Message for Adding
  const nextStartByMode = React.useMemo(() => {
    return ["NEFT", "IMPS", "RTGS"].reduce((acc, mode) => {
      const slabs = commissionSlab
        .filter((s) => s.mode === mode)
        .sort((a, b) => a.start_amount - b.start_amount);

      acc[mode] = slabs.length ? slabs[slabs.length - 1].end_amount + 1 : 0;
      return acc;
    }, {});
  }, [commissionSlab]);

  const nextStatrtByModeMandate = React.useMemo(() => {
    return ["DAILY", "NON-DAILY"].reduce((acc, mode) => {
      const slabs = commissionSlab
        .filter((s) => s.mode === mode)
        .sort((a, b) => a.start_amount - b.start_amount);
      acc[mode] = slabs.length ? slabs[slabs.length - 1].end_amount + 1 : 0;
      return acc;
    }, {});
  }, [commissionSlab]);

  const handleDeleteSlab = (index) => {
    setDeletIndex(index);
    const updatedSlabs = [...commissionSlab];
    updatedSlabs.splice(index, 1);
    setCommisssionSlab(updatedSlabs);
  };
  // handleSubmitPackageLinking();

  const handleEditSlab = (index) => {
    setEditIndex(index);
    const slabToEdit = commissionSlab[index];

    // Determine if the selected service is Recharge
    const isRecharge =
      selectedService &&
      serviceData.find((s) => s.id === Number(selectedService))?.end_point ===
        "/bills-api/recharge";

    // Set fields to edit mode
    setfrom_amt_val(slabToEdit.start_amount);
    setto_amt_val(slabToEdit.end_amount);
    setCharges(slabToEdit.amount);
    setChargeType(slabToEdit.commission_type);

    if (isRecharge) {
      setSelectedOperator(slabToEdit.operator_id || ""); // <--- for dropdown
      setPaymentMode(""); // hide payment mode for Recharge
    } else {
      setPaymentMode(slabToEdit.mode || "");
      setSelectedOperator(""); // hide operator for non-Recharge
    }

    // Remove the slab from list temporarily
    const updatedSlabs = [...commissionSlab];
    updatedSlabs.splice(index, 1);
    setCommisssionSlab(updatedSlabs);
  };

  const getStatus = (code) => {
    switch (code) {
      case 5:
        return { text: "Active", color: "text-green-600" };
      case 4:
        return { text: "Inactive", color: "text-red-600" };
      case 18:
        return { text: "Deprecated", color: "text-yellow-600" };
      case 19:
        return { text: "Coming Soon", color: "text-blue-600" };
      default:
        return { text: "", color: "text-gray-500" };
    }
  };

  const status = getStatus(statusRes);

  // fetch all packages charges when service
  useEffect(() => {
    if (!selectedService) return; // do nothing if no service selected

    const getAllPackagesCharges = async () => {
      try {
        const response = await fetchAllPackagesCharges({
          service_id: selectedService,
        });
        console.log("All Packages Charges", response);

        setShowAllPackageCharges(response.data || []);
      } catch (error) {
        console.error(error);
      }
    };

    getAllPackagesCharges();
  }, [selectedService]);

  useEffect(() => {
    console.log("commission_slabs", commissionSlab);

    console.log("selected Service", selectedService);
  }, [commissionSlab, selectedService]);

  return (
    <>
      <Seo />
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2 }}
      >
        <DivTag
          id=""
          className="border-2 border-solid border-blue-800 rounded-xl mt-12 bg-white"
        >
          <ReportHeading name="&nbsp;&nbsp; Commission Master&nbsp;&nbsp;" />
          <button
            onClick={openPopup}
            id="create_package"
            type="button"
            className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-3 py-2 text-center absolute md:top-[55px] mt-1 right-[5px] mb-2"
          >
            Create Package
          </button>
          <Popup
            isOpen={isOpen}
            onClose={closePopup}
            popupMainContentClass="w-[30%] h-1/2 overflow-y-scroll"
          >
            <div className="flex justify-center">
              <p className="bg-blue-600 rounded-md text-white px-1 mb-4">
                Create Package
              </p>
            </div>
            <div className="flex gap-2 justify-center">
              <InputWithLabel
                label="Package Name"
                placeholder="Enter Package Name"
                value={packageName}
                //  onChange={change_color_default}
                onChange={(e) => setPackageName(e.target.value)}
                name="add_package"
                id=""
                type="text"
              />
              <Button
                onClick={AddPackageData}
                id="add_btn"
                type="submit"
                className="text-center  h-fit text-white bg-blue-700 shadow-lg bg-gradient-to-r mt-6 from-blue-900 via-teal-400 to-purple-900 font-semibold rounded-md px-1 text-xl hover:bg-red-300"
              >
                Add
              </Button>
            </div>
            <div className="w-full mt-2">
              <table className="w-full table ">
                <thead>
                  <tr className="bg-blue-700 text-white">
                    <th>SN</th>
                    <th>Package Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {packageData.length > 0 ? (
                    packageData.map((value, index) => (
                      <tr key={index}>
                        <td className="border-2 px-1 md:px-0 py-0 text-center">
                          {index + 1}
                        </td>
                        <td className="border-2 px-1 md:px-0 py-0 text-center">
                          {editingPackageId === value.id ? (
                            <input
                              type="text"
                              value={newName}
                              onChange={(e) => setNewName(e.target.value)}
                              className="border rounded px-0 py-0"
                            />
                          ) : (
                            value.name
                          )}
                        </td>
                        <td className="border-2 px-2 md:px-4 py-2 text-center">
                          {editingPackageId === value.id ? (
                            <button
                              className="bg-green-600 text-white rounded-md text-xs px-1"
                              onClick={() => handleUpdate(value.id)}
                            >
                              Update
                            </button>
                          ) : (
                            <button
                              className="bg-blue-600 rounded-md text-white text-xs px-1 me-1"
                              onClick={() => handleEdit(value.id, value.name)}
                            >
                              Edit
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <div className="flex items-center gap-4 text-xl text-neutral-600 justify-center">
                      <FaInbox />
                      <p className="flex justify-center items-center">
                        Data not found
                      </p>
                    </div>
                  )}
                </tbody>
              </table>
            </div>
          </Popup>

          <form method="" autoComplete="off">
            <div className="flex flex-wrap justify-center pt-1 mt-2 gap-2">
              {/* new select service with search and dropdown functionality */}
              <div className="w-full md:w-1/5 px-2 relative">
                <label className="block mb-1 font-semibold text-gray-700">
                  Select Service
                </label>

                <div
                  className={`w-full p-1 rounded border cursor-text focus-within:outline-none ${
                    errors.service ? "border-red-500" : "border-blue-600"
                  }`}
                  onClick={() => setOpenServiceDropDown(true)}
                >
                  <input
                    type="text"
                    value={serviceLabel}
                    placeholder="Select Service"
                    onChange={(e) => {
                      setServiceLabel(e.target.value);
                      console.log(e.target.value);
                      setSelectedService(""); // reset ID because user is typing
                      setOpenServiceDropDown(true);
                    }}
                    className="w-full focus:outline-none"
                  />
                </div>

                {openServiceDropDown && (
                  <ul className="absolute z-20 w-[calc(100%-1rem)] bg-white border border-blue-600 rounded mt-1 max-h-[40rem] overflow-y-auto">
                    <button
                      onClick={() => setOpenServiceDropDown(false)}
                      className="flex sticky top-0 items-center justify-center w-full gap-2 px-4 py-1 font-semibold text-white transition-all duration-200 bg-blue-600  shadow-sm hover:bg-red-700 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 active:scale-[0.98]"
                    >
                      <ChevronUpCircleIcon className="w-4 h-4" />
                      <span>Close</span>
                    </button>{" "}
                    {isLoading ? (
                      <p className="px-1 py-1 animate-pulse text-gray-600">
                        Loading Services.....
                      </p>
                    ) : filteredServices.length > 0 ? (
                      filteredServices.map((item) => (
                        <li
                          key={item.id}
                          onMouseDown={() => {
                            setSelectedService(item.id); // store ID
                            setServiceLabel(item.service_name); // display name
                            setOpenServiceDropDown(false);
                          }}
                          className="px-2 py-1 cursor-pointer hover:bg-blue-100"
                        >
                          {item.service_name}
                        </li>
                      ))
                    ) : (
                      <li className="px-2 py-1 text-gray-500">
                        No service found
                      </li>
                    )}
                  </ul>
                )}

                <div>
                  <p className={`${status.color} font-bold`}>{status.text}</p>
                </div>

                {errors.service && (
                  <p className="text-red-500 text-sm mt-1">{errors.service}</p>
                )}
              </div>

              {/* Select Package */}
              <div className="w-full md:w-1/5 px-2">
                <label
                  htmlFor="select_package"
                  className="block mb-1 font-semibold text-gray-700"
                >
                  Select Package
                </label>
                <select
                  id="select_package"
                  name="select_package"
                  value={selectedPackageId}
                  onChange={(e) => setSelectedPackageId(e.target.value)}
                  onBlur={handleBlur}
                  className={`w-full p-1 rounded border focus:outline-none ${errors.service ? "border-red-500" : "border-blue-600"}`}
                  required
                >
                  <option value="" disabled>
                    Select Package
                  </option>
                  {packageData.length > 0 &&
                    packageData.map((value, index) => (
                      <option key={index} value={value.id}>
                        {value.name}
                      </option>
                    ))}
                </select>
                {errors.service && (
                  <p className="text-red-500 text-sm mt-1">{errors.service}</p>
                )}
              </div>

              {/* {serviceLabel === "Create Mandate V2" && (
              <div className=" flex justify-center flex-col gap-2 px-2">
                <label htmlFor="">Select Debit Type</label>
                <select name="" id="" className="border rounded-md p-1 border-blue-700">
                  <option value="">select Debit Type</option>
                  <option value="transaction">transaction</option>
                  <option value="registration"> registration</option>
                </select>
              </div>
            )} */}

              {/* Submit Button */}
              <div className="w-full md:w-auto px-2 mt-[26px]">
                <button
                  type="button"
                  onClick={handleSubmitPackageLinking}
                  className="w-full bg-gradient-to-r from-blue-900 via-teal-400 to-purple-900 text-white px-3 py-1 rounded-md font-semibold shadow hover:opacity-90 transition"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
          <div className="d-none" id="bottom_content">
            <form method="post" action="">
              {filterSelctedItem()[0]?.adjustment_type === "charge" &&
              selectedService &&
              serviceData.find((s) => s.id === Number(selectedService))
                ?.end_point !== "/idfc/fund-transfer" ? (
                <div className="flex flex-wrap justify-center pt-1 mt-2 gap-1">
                  {/* Select Type */}
                  <div className="w-full md:w-1/6 px-2">
                    <label
                      htmlFor="service_bottom"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Select Type
                    </label>
                    <select
                      id="service_bottom"
                      name="service_bottom"
                      value={chargeType}
                      onChange={(e) => setChargeType(e.target.value)}
                      className="w-full p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
                      required
                    >
                      <option value="">Select Type</option>
                      <option value="Flat">Flat</option>
                      <option value="Percentage">Percentage</option>
                    </select>
                  </div>
                  <div className="w-full md:w-1/5 px-1">
                    <label
                      htmlFor="commission_amt_"
                      className="block font-medium text-gray-700 mb-1 text-xs"
                    >
                      Charge & Commission Master
                    </label>
                    <input
                      type="number"
                      name="commission_amt_"
                      id="commission_amt_"
                      placeholder="Enter Charges Amount"
                      value={charges}
                      onChange={(e) => setCharges(e.target.value)}
                      className="w-full p-1 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
                      required
                    />
                  </div>
                </div>
              ) : (
                <div className="flex flex-wrap justify-center pt-3 mt-2 gap-1">
                  {/* Operator Field - show only if service end_point is "/bills-api/recharge" */}
                  {selectedService &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point === "/bills-api/recharge" && (
                      <div className="w-full md:w-1/6 px-2">
                        <label className="block mb-1 font-semibold text-gray-700">
                          Select Operator
                        </label>
                        <select
                          value={selectedOperator}
                          onChange={handleChange}
                          className="rounded-sm border border-blue-700 p-1 w-full"
                        >
                          <option value="">Select Operator</option>
                          {operators.map((op) => (
                            <option
                              key={op.id || op.operator_id}
                              value={op.id || op.operator_id}
                            >
                              {op.name || op.operator_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                  {/* Payment Mode - hide if service end_point is "/bills-api/recharge"    and  /auto-debit-r/mandate/create */}
                  {selectedService &&
                    [
                      "/bills-api/recharge",
                      "/auto-debit-r/mandate/create",
                    ].includes(
                      serviceData.find((s) => s.id === Number(selectedService))
                        ?.end_point,
                    ) && (
                      <div className="w-full md:w-1/6 px-2">
                        <label
                          htmlFor="payment_mode"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Select Mode
                        </label>

                        <select
                          id="payment_mode"
                          name="payment_mode"
                          value={paymentMode}
                          onChange={(e) => setPaymentMode(e.target.value)}
                          className="w-full p-2 border border-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
                        >
                          <option value="">Payment Mode</option>
                          <option value="NEFT">NEFT</option>
                          <option value="IMPS">IMPS</option>
                          <option value="RTGS">RTGS</option>
                        </select>
                      </div>
                    )}

                  {selectedService &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point !== "/bills-api/recharge" &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point === "/auto-debit-r/mandate/create" && (
                      <div className="w-full md:w-1/6 px-2">
                        <label
                          htmlFor="debit_type"
                          className="block text-sm font-medium text-gray-700 mb-1"
                        >
                          Debit Type
                        </label>

                        <select
                          id="debit_type"
                          name="debit_type"
                          value={debitType}
                          onChange={(e) => setDebitType(e.target.value)}
                          className="w-full p-2 border border-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
                        >
                          <option value="">Debit Type</option>
                          <option value="Registration">Registration</option>
                          <option value="Transaction">Transaction</option>
                        </select>
                      </div>
                    )}

                  {serviceData.find((s) => s.id === Number(selectedService))
                    ?.end_point === "/auto-debit-r/mandate/create" && (
                    <div className="w-full md:w-1/6 px-2">
                      <label
                        htmlFor="payment_mode"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Select Mode
                      </label>
                      <select
                        id="payment_mode"
                        name="payment_mode"
                        value={paymentMode}
                        onChange={(e) => setPaymentMode(e.target.value)}
                        className="w-full p-2 border border-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
                      >
                        <option value="">Select Mode</option>
                        <option value="DAILY">DAILY</option>
                        <option value="NON-DAILY">NON-DAILY</option>
                      </select>
                    </div>
                  )}

                  {/* From Amount */}

                  {(debitType === "Transaction" ||
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point === "/idfc/fund-transfer") && (
                    <div className="w-full md:w-1/6 px-2">
                      <label
                        htmlFor="from_amt_"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        From Amount
                      </label>
                      <input
                        type="text"
                        name="from_amt_"
                        id="from_amt_"
                        placeholder="Enter From Amount"
                        value={from_amt_val}
                        onChange={handleFromAmt}
                        className="w-full p-1 border border-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
                      />
                    </div>
                  )}

                  {/* To Amount */}
                  {(debitType === "Transaction" ||
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point === "/idfc/fund-transfer") && (
                    <div className="w-full md:w-1/6 px-2">
                      <label
                        htmlFor="to_amt_"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        To Amount
                      </label>
                      <input
                        type="text"
                        name="to_amt_"
                        id="to_amt_"
                        placeholder="Enter To Amount"
                        value={to_amt_val}
                        onChange={handleToAmt}
                        className="w-full p-1 border border-blue-600 rounded focus:outline-none focus:ring-2 focus:ring-blue-600"
                      />
                    </div>
                  )}

                  <div className="w-full md:w-1/5 px-2">
                    <label
                      htmlFor="commission_amt_"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Charge & Commission Master
                    </label>
                    <input
                      type="number"
                      name="commission_amt_"
                      id="commission_amt_"
                      placeholder="Enter Charges Amount"
                      value={charges}
                      onChange={(e) => setCharges(e.target.value)}
                      className="w-full p-1 border border-blue-600 rounded"
                      required
                    />
                  </div>

                  {/* Commission Type */}
                  <div className="w-full md:w-1/6 px-2">
                    <label
                      htmlFor="commission_type"
                      className="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Select Type
                    </label>
                    <select
                      id="commission_type"
                      name="commission_type"
                      value={chargeType}
                      onChange={(e) => setChargeType(e.target.value)}
                      className={`w-full p-1 border rounded border-blue-600 ${errors.service ? "border-red-500" : "border-blue-600"}`}
                    >
                      <option value="">Select Type</option>
                      <option value="Flat">Flat</option>
                      <option value="Percentage">Percentage</option>
                    </select>
                    {errors.service && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.service}
                      </p>
                    )}
                  </div>

                  {/* Add Button */}
                  {debitType === "Transaction" && (
                    <div className="w-full md:w-auto px-1 mt-4">
                      <button
                        type="button"
                        id="add_bottom_data"
                        onClick={addCommissionSlab}
                        className="bg-gradient-to-r from-blue-900 via-teal-400 to-purple-900 text-white px-3 py-1 rounded-md font-semibold shadow hover:opacity-90 transition"
                      >
                        {editIndex !== null ? "Update" : "Add"}
                      </button>
                    </div>
                  )}

                  {/* Payment Mode - hide if service end_point is "/bills-api/recharge" */}
                  {selectedService &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point !== "/bills-api/recharge" &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point !== "/auto-debit-r/mandate/create" && (
                      <div className="flex flex-col md:flex-row gap-2">
                        {["NEFT", "IMPS", "RTGS"].map((mode) => (
                          <div
                            key={mode}
                            className="text-sm text-gray-600 font-semibold"
                          >
                            Next {mode} slab: ₹{nextStartByMode[mode]}
                          </div>
                        ))}
                      </div>
                    )}

                  {selectedService &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point !== "/bills-api/recharge" &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point !== "/idfc/fund-transfer" && (
                      <div className="flex flex-col md:flex-row gap-2">
                        {["DAILY", "NON-DAILY"].map((mode) => (
                          <div
                            key={mode}
                            className="text-sm text-gray-600 font-semibold"
                          >
                            Next {mode} slab: ₹{nextStatrtByModeMandate[mode]}
                          </div>
                        ))}
                      </div>
                    )}

                  {/* Operator Info - show only if service end_point is "/bills-api/recharge" */}
                  {selectedService &&
                    serviceData.find((s) => s.id === Number(selectedService))
                      ?.end_point === "/bills-api/recharge" && (
                      <div className="flex flex-col md:flex-row gap-2">
                        {Object.entries(
                          commissionSlab.reduce((acc, slab) => {
                            if (!slab.operator_id) return acc; // skip if no operator_id
                            if (!acc[slab.operator_id])
                              acc[slab.operator_id] = [];
                            acc[slab.operator_id].push(slab);
                            return acc;
                          }, {}),
                        ).map(([operatorId, slabs]) => {
                          const nextStart = slabs.length
                            ? Math.max(...slabs.map((s) => s.end_amount)) + 1
                            : 0;

                          const operatorName =
                            operators.find(
                              (op) =>
                                String(op.id || op.operator_id) === operatorId,
                            )?.name || "N/A";

                          return (
                            <div
                              key={operatorId}
                              className="text-sm text-gray-600 font-semibold"
                            >
                              Next {operatorName} slab: ₹{nextStart}
                            </div>
                          );
                        })}
                      </div>
                    )}

                  {/* Commission Slab Table */}
                </div>
              )}
            </form>
          </div>

          <ToastContainer />
        </DivTag>
      </motion.div>

      {commissionSlab.length > 0 && (
        <div className="w-full flex justify-center mt-6 overflow-x-auto">
          <table className="w-full md:w-1/2 table-auto border border-gray-300 text-center text-sm">
            <thead className="bg-blue-700 text-white">
              <tr>
                <th className="border p-1">SN</th>
                <th className="border p-1">Amount</th>
                <th className="border p-1">From Amount</th>
                <th className="border p-1">To Amount</th>
                <th className="border p-1">
                  {selectedService &&
                  serviceData.find((s) => s.id === Number(selectedService))
                    ?.end_point === "/bills-api/recharge"
                    ? "Operator"
                    : "Payment Mode"}
                </th>
                <th className="border p-1">Commission Type</th>
                <th className="border p-1">Actions</th>
              </tr>
            </thead>

            <tbody>
              {commissionSlab.map((item, index) => {
                const isRecharge =
                  selectedService &&
                  serviceData.find((s) => s.id === Number(selectedService))
                    ?.end_point === "/bills-api/recharge";

                // Determine last item per mode (for normal) or per operator (for Recharge)
                const isLast =
                  index ===
                  [...commissionSlab]
                    .map((itm, i) => ({
                      key: isRecharge ? itm.operator_id : itm.mode,
                      index: i,
                    }))
                    .filter(
                      (i) =>
                        i.key === (isRecharge ? item.operator_id : item.mode),
                    )
                    .slice(-1)[0].index;

                return (
                  <tr key={index} className="bg-white hover:bg-gray-100">
                    <td className="border px-1 py-0">{index + 1}</td>
                    <td className="border px-1 py-0">
                      ₹{item.amount || "N/A"}
                    </td>
                    <td className="border px-1 py-0">
                      ₹{item.start_amount || "N/A"}
                    </td>
                    <td className="border px-1 py-0">
                      ₹{item.end_amount || "N/A"}
                    </td>
                    <td className="border px-1 py-0">
                      <td className="border px-1 py-0">
                        {isRecharge
                          ? item.operator_id || "N/A"
                          : item.mode || "N/A"}
                      </td>
                    </td>
                    <td className="border px-1 py-0">
                      {item.commission_type || "N/A"}
                    </td>
                    <td className="border px-1 py-0">
                      {isLast && (
                        <div className="flex space-x-1">
                          <button
                            type="button" // Important: prevent form submit
                            onClick={() => handleEditSlab(index)}
                            className="text-white bg-green-600 hover:bg-green-700 rounded-md px-1 py-0 text-sm"
                          >
                            Edit
                          </button>
                          <button
                            type="button" // Important: prevent form submit
                            onClick={() => handleDeleteSlab(index)}
                            className="text-white bg-red-600 hover:bg-red-700 rounded-md px-1 py-0 text-sm"
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {commissionSlab.length === 0 && showAllPackageCharges.length > 0 && (
        <div className="bg-white w-full h-30 rounded-md mt-6 p-4">
          <table className="w-full table-auto text-center border-collapse border border-gray-300 px-2 py-1">
            <thead>
              <tr className="bg-blue-700 text-white rounded-md">
                <th className="px-2 py-1 rounded-md">Package Name</th>
                <th className="px-2 py-1 rounded-md">Charge Type</th>
                <th className="px-2 py-1 rounded-md">Amount</th>
              </tr>
            </thead>
            <tbody>
              {showAllPackageCharges.map((item, index) => (
                <tr key={index} className="text-center">
                  <td className="border px-2 py-1">
                    {item.package_name || "N/A"}
                  </td>
                  <td className="border px-2 py-1">
                    {item.charge?.charge_type || "N/A"}
                  </td>
                  <td className="border px-2 py-1">
                    ₹{item.charge?.amount || "N/A"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default CommissionMaster;
